const STATUS_CHIP_CLASSES = {
  Gray: "bg-gray-100 border-gray-400 text-gray-900",
  DarkSky: "bg-sky-100 border-sky-600 text-gray-900",
  Success: "bg-green-100 border-green-600 text-gray-900",
  LightLime: "bg-lime-100 border-lime-500 text-gray-900",
  DarkYellow: "bg-yellow-100 border-yellow-600 text-gray-900",
};

export function getEventChipClassName(event) {
  const type = event?.status?.type;
  const base =
    STATUS_CHIP_CLASSES[type] ||
    "bg-gray-100 border-gray-400 text-gray-900";

  if (event?.is_overdue) {
    return `${base} ring-1 ring-red-500`;
  }

  return base;
}
